module.exports = __webpack_public_path__ + "img/eye.ee7f330e.svg";